import {Component} from '@angular/core';
import {AppState} from "@store/state/app.state";
import {Store} from "@ngrx/store";
import {ConfigState} from "@store/state/config.state";
import {Observable} from "rxjs";

@Component({
    selector: 'iw-shop-dynamic-page-default-imprint',
    standalone: false,
    templateUrl: './default-imprint.component.html',
    styleUrls: ['./default-imprint.component.scss']
})

export class DefaultImprintComponent {

    config$: Observable<ConfigState>;
    constructor(private store: Store<AppState>) {
        this.config$ = this.store.select(state => state.config);
    }
}
